import { render, staticRenderFns } from "./TeacherTeam.vue?vue&type=template&id=2ba6c6cf&scoped=true"
import script from "./TeacherTeam.vue?vue&type=script&lang=js"
export * from "./TeacherTeam.vue?vue&type=script&lang=js"
import style0 from "./TeacherTeam.vue?vue&type=style&index=0&id=2ba6c6cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6c6cf",
  null
  
)

export default component.exports